<template>
        <div class="p-fluid formgrid grid">
            <div class="field col-12">
                <Image
                    src="https://treetan-storage.is3.cloudhost.id/uploads-production/0000/1/2021/09/29/rekanan-travel-dengan.webp"
                    preview="true"
                    width="250"
                />
            </div>
            <div class="field col-12 md:col-3">
                <label for="name3">Applied Position</label>
                <InputText id="id_card_number" type="text" v-model="model.applied_position_name" readonly />
            </div>
            <div class="field col-12 md:col-3">
                <label for="name3">ID Card Number</label>
                <InputText id="id_card_number" type="text" v-model="model.id_card_number" :disabled="isDisabled"/>
            </div>
            <div class="field col-12">
                <label for="name3">Name</label>
                <InputText id="name" type="text" v-model="model.name" :disabled="isDisabled" />
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Gender</label>
                <Dropdown v-model="model.gender" :options="genderValues" optionLabel="name" optionValue="code" placeholder="Select Gender" :class="{'p-invalid' : submitted && !model.gender}" :disabled="isDisabled"/>
                    <small class="p-invalid" v-if="submitted && !model.gender"
        >Gender is required.
                    </small>
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Birthplace</label>
                <InputText id="birthplace" type="text" v-model="model.birthplace" :disabled="isDisabled" />
            </div>
            <div class="field col-12 md:col-5">
                <label for="email3">Birth Date</label>
                <Calendar :showIcon="true"
                        :showButtonBar="true"
                        v-model="model.birthdate"
                        :class="{'p-invalid' : submitted && !model.birthdate}"
                        dateFormat="yy-mm-dd"
                        :disabled="isDisabled">
                </Calendar>
                <small class="p-invalid" v-if="submitted && !model.birthdate"
                    >Birthdate is required.</small
                >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Email</label>
                    <InputText id="email3" type="text" v-model="model.email" :disabled="isDisabled"/>
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Telephone Number</label>
                    <InputText id="birthplace" type="text" v-model="model.telephone_number" :disabled="isDisabled"/>
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Phone Number</label>
                    <InputText id="birthplace" type="text" v-model="model.phone_number" :disabled="isDisabled"/>
            </div>
            <div class="field col-12">
                <label for="email3">Address</label>
                    <TextArea
                        id="address"
                        name="address"
                        v-model="model.address"
                        required="true"
                        rows="5"
                        cols="50"
                        :class="{'p-invalid' : submitted && !model.address}"
                        :disabled="isDisabled"
                    >
                    </TextArea>
                    <small class="p-invalid" v-if="submitted && !model.address"
                        >Address is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Blood Type</label>
                    <Dropdown v-model="model.blood_type" :options="bloodTypeValues" placeholder="Select Blood Type" :class="{'p-invalid' : submitted && !model.blood_type}" :disabled="isDisabled"/>
                    <small class="p-invalid" v-if="submitted && !model.blood_type"
                        >Blood Type is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">Last Education</label>
                    <Dropdown v-model="model.last_formal_education" :options="lastEducationLevels" optionLabel="name" optionValue="id" placeholder="Select Education Level" :class="{'p-invalid' : submitted && !model.last_formal_education}" :disabled="isDisabled"/>
                    <small class="p-invalid" v-if="submitted && !model.last_formal_education"
                        >Last Education Level is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">GPA</label>
                    <InputText id="birthplace" type="text" v-model="model.gpa" :disabled="isDisabled"/>
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Religion</label>
                    <Dropdown v-model="model.religion" :options="religions" placeholder="Select Religion" :class="{'p-invalid' : submitted && !model.religion}" :disabled="isDisabled"/>
                    <small class="p-invalid" v-if="submitted && !model.religion"
                        >Religion is required.</small
                    >
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Nationality</label>
                <InputText id="birthplace" type="text" v-model="model.nationality" :disabled="isDisabled"/>
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Clan</label>
                <InputText id="birthplace" type="text" v-model="model.clan" :disabled="isDisabled"/>
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Marital Status</label>
                <Dropdown v-model="model.marital_status" :options="maritalStatus" placeholder="Select Marital Status" :class="{'p-invalid' : submitted && !model.marital_status}" :disabled="isDisabled"/>
                <small class="p-invalid" v-if="submitted && !model.marital_status"
                    >Marital Status is required.</small
                >
            </div>
        </div>
</template>
<script>
import axios from 'axios';
import { FilterMatchMode } from "primevue/api";
import InputText from 'primevue/inputtext';
import Button from "primevue/button";
import Image from "primevue/image";
import TextArea from "primevue/textarea";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';
import DatatableService from "../../../../Services/DatatableService";

export default {
    components:{
        Button,
        InputText,
        TextArea,
        Dropdown,
        Calendar,
        Image,
    },
    props: ['isDisabled','model'],
    data(){
        return{
            form: {},
            genderValues: [
                {name: 'Laki-Laki', code: 'Laki-laki'},
                {name: 'Perempuan', code: 'Perempuan'},
            ],
            bloodTypeValues: ["A", "B", "O", "AB"],
            religions:['Islam','Katolik','Kristen','Hindu','Budha'],
            maritalStatus:['married','single','widow'],
            submitted:false,
            lastEducationLevels:null,
            lazyParams: null,
        }
    },
    created(){
        this.datatableService = new DatatableService();
    },
    mounted(){
        this.filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.initData();
    },
    methods:{
        initData(){
            this.datatableService
            .getData(this.route("education.levels"), this.lazyParams)
            .then((data) => {
                this.lastEducationLevels = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            })
        },
    }
}
</script>
